import { useEffect, useRef, useState } from 'react';

export function useThrottle<T>(value: T, time = 1000): T {
  const [throttledValue, setThrottledValue] = useState(value);
  const lastRan = useRef(Date.now());

  useEffect(() => {
    const handler = setTimeout(function () {
      if (Date.now() - lastRan.current >= time) {
        setThrottledValue(value);
        lastRan.current = Date.now();
      }
    }, time - (Date.now() - lastRan.current));

    return () => {
      clearTimeout(handler);
    };
  }, [value, time]);

  return throttledValue;
}
